import { useState } from 'react'

import { Button, Popup, TeslaIntegrationSetupGuide } from '@/components'
import { InverterManufacturer } from '@/models'

export const TeslaTroubleshooting = () => {
    const [showDINGuide, setShowDINGuide] = useState(false)
    const [showIntegrationGuide, setShowIntegrationGuide] = useState(false)

    return <>
        <div className="bg-primary-25 p-4 rounded-lg text-gray-750 text-sm flex flex-col gap-4">
            <h4 className="font-semibold">
                Tesla systems require manual site-level setup to share monitoring data. Unlike Enphase or SolarEdge
                (which allow full fleet data sharing), each Tesla site must be individually shared with Solar Insure.
            </h4>
            <div className="bg-primary-100 rounded-2xl p-4 flex flex-col gap-4">
                <h5 className="font-bold">Step One: Ensure the Warranty Has a Valid DIN</h5>
                <ul className="list-decimal pl-5">
                    <li>
                        Go to the <span className="font-semibold">Warranty Holder Details – Warranty Tab</span>.
                    </li>
                    <li>
                        Check that the Manufacturer System ID field contains a valid Tesla DIN (e.g.,
                        ABC1234-X1-Y--ZXY45678LMNOP4).
                    </li>
                    <li>
                        If missing or incorrect, click Edit Warranty and update the field.
                    </li>
                    <li>
                        Need help? <Button
                            design="btn-link"
                            className="text-primary-600 underline inline"
                            onClick={() => {
                                setShowDINGuide(true)
                            }}
                        >
                            How to Find Tesla DIN
                        </Button>.
                    </li>
                </ul>

                <p className="italic">
                    <span className="not-italic">⚠️</span> <span className="font-semibold">Important:</span> Tesla’s API
                    only accepts the DIN for matching — we cannot use the Site Name (e.g., STE20250530-01115), address,
                    or homeowner contact information.
                </p>
            </div>
            <div className="bg-primary-100 rounded-2xl p-4 flex flex-col gap-4 items-start">
                <h5 className="font-semibold">Step Two: Share the Tesla Site with Solar Insure</h5>
                <h6 className="font-semibold">Option A – Tesla One App (During Installation)</h6>
                <ul className="list-decimal pl-5">
                    <li>Add Solar Insure as a monitoring partner in the app during commissioning.</li>
                </ul>
                <h6 className="font-semibold">Option B – After Installation in Tesla Powerhub</h6>
                <ul className="list-decimal pl-5">
                    <li>Log into Tesla Powerhub.</li>
                    <li>Open the site and click “Site Sharing” in the left sidebar.</li>
                    <li>Share with Solar Insure.</li>
                </ul>
                <p>For more visual instructions, view the guide below:</p>

                <Button
                    onClick={() => {
                        setShowIntegrationGuide(true)
                    }}
                >
                    View Tesla Integration Setup Guide
                </Button>
            </div>
            <div className="bg-primary-100 rounded-2xl p-4 flex flex-col gap-4">
                <h5 className="font-semibold">Step Three: Click the “Refresh Monitoring” Button.</h5>
                <p>After entering a valid DIN and sharing the site:</p>
                <p>
                    Click the <span className="font-bold">“Refresh Monitoring”</span> button above to:
                </p>
                <ul className="list-disc pl-5">
                    <li>Match the DIN to Tesla Powerhub</li>
                    <li>Pull monitoring data if found</li>
                    <li>Instantly update the system’s status</li>
                </ul>
            </div>
        </div>

        <Popup
            className="w-200"
            open={showDINGuide}
            onClose={() => {
                setShowDINGuide(false)
            }}
        >
            {InverterManufacturer.tesla.systemIdGuide}
        </Popup>

        <Popup
            className="w-200"
            open={showIntegrationGuide}
            onClose={() => {
                setShowIntegrationGuide(false)
            }}
        >
            <TeslaIntegrationSetupGuide
                onComplete={() => {
                    setShowIntegrationGuide(false)
                }}
            />
        </Popup>
    </>
}
